import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class IntegrationFailureModel {
    static fromScoutDTO(date, customFailure) {
        return new IntegrationFailureModel({
            date,
            customFailure: {
                code: customFailure.code,
                param: customFailure.param,
                paramPendingSync: customFailure.paramPendingSync,
                paramLink: undefined
            }
        });
    }
    failureCode() {
        return this.data.customFailure.code;
    }
    failureParam() {
        return this.data.customFailure.param;
    }
    invoicesToSync() {
        const { paramPendingSync } = this.data.customFailure;
        return paramPendingSync ? paramPendingSync.invoicesToSync : [];
    }
    paymentsToSync() {
        const { paramPendingSync } = this.data.customFailure;
        return paramPendingSync ? paramPendingSync.paymentsToSync : [];
    }
    date() {
        return new Date(this.data.date);
    }
    paramLink() {
        return this.data.customFailure.paramLink;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
